module.exports = __webpack_public_path__ + "img/guides.35bc589.png";